// @flow
import type { ContentTypeInput } from './RemoveContent.gql';

/** Enum type exposed to components. For documentation purposes only since we don't actually have types to deduce that typename is an enum */
export type ContentType =
  | 'Review'
  | 'ForumPost'
  | 'LinkPost'
  | 'Repost'
  | 'Trip'
  | 'Video'
  | 'Photo'
  | 'MediaBatch'
  | string;

/** The representation of an content object that has been suppressed */
export type ContentTypePairKey = [ContentType, string];

/** Converts a __typename enum into a ContentTypeInput enum */
export const convert = (type: ContentType): ?ContentTypeInput => {
  const words = type.match(/[A-Z]+[^A-Z]+/g);
  if (!Array.isArray(words)) {
    return null;
  }
  const strippedOutWords = words.map(word => word.replace(/[^a-zA-Z]/, ''));
  const totalLength = strippedOutWords.reduce((length, word) => length + word.length, 0);
  if (type.length !== totalLength) {
    return null;
  }

  return (strippedOutWords.join('_').toUpperCase(): any);
};
